import styled from "styled-components";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  .columns {
    margin-bottom: 0 !important;
  }
  .error {
    color: red;
    margin-bottom: 15px;
  }
  .submit {
    width: 10rem;
  }
`;
